import React, { useEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

interface AmDonutChartProps {
  id: string;
  data: Array<{ category: string; value: number }>;
  height: string;
  colors: string[];
}

export const AmDonutChart3D: React.FC<AmDonutChartProps> = (props) => {
  am4core.useTheme(am4themes_animated);

  let chart: am4charts.PieChart3D | undefined;
  const totalCount = props.data.reduce((n, { value }) => n + value, 0);

  useEffect(() => {
    chart = am4core.create(props.id, am4charts.PieChart3D);

    const series = chart.series.push(new am4charts.PieSeries3D());
    if (chart.logo) {
      chart.logo.disabled = true;
    }
    series.dataFields.value = 'value';
    series.dataFields.category = 'category';
    series.innerRadius = am4core.percent(50);

    const label = series.createChild(am4core.Label);
    label.text = totalCount.toLocaleString('en-IE') || '0';
    label.horizontalCenter = 'middle';
    label.verticalCenter = 'middle';
    label.fontSize = 20;
    label.fill = am4core.color('#1D3E41');

    chart.legend = new am4charts.Legend();
    series.labels.template.disabled = true;
    series.hiddenState.properties.opacity = 1;
    series.hiddenState.properties.endAngle = -90;
    series.hiddenState.properties.startAngle = -90;

    const colors = props.colors?.map((c) => {
      return am4core.color(c);
    });

    series.colors.list = colors;

    if (chart) {
      chart.data = props.data;
    }
    // Handle all-zero values case
    if (totalCount === 0) {
      chart.data = [{ category: 'No Employees', value: 1 }];
      label.text = '0';
      label.fill = am4core.color('#1D3E41');

      // Disable percentage labels
      series.labels.template.disabled = true;
      series.ticks.template.disabled = true;
      series.slices.template.tooltipText = ''; // Remove tooltips showing 100%
      series.colors.list = [am4core.color('#1C3E41')];
    } else {
      chart.data = props.data;
    }
    return () => {
      if (chart) {
        chart.dispose();
      }
    };
  }, [props.id, chart, props.data]);

  return (
    <div
      id={props.id}
      style={{ width: '100%', height: props.height, background: '#F9F9F9' }}
    />
  );
};
